export default __webpack_public_path__ + "partner_6d8223c.png";